(function (factory) {
    typeof define === 'function' && define.amd ? define(factory) :
    factory();
}((function () { 'use strict';

    var Menu = function Menu() {
        this.scrollY = 0;
        this.initializeScrollEvent();
        this.initializeMegaMenu();
    };

    Menu.prototype.initializeScrollEvent = function initializeScrollEvent () {
        var cssClass = 'scrolled';
        var scrollLength = 20;
        var headerContainer = document.querySelector('.header__container');
        var lastScrollTop=  0;

        window.addEventListener(
            'scroll',
            function handleScroll() {
                var scrollTopPosition =
                    window.pageYOffset || document.documentElement.scrollTop;

                lastScrollTop =
                    scrollTopPosition <= 0 ? 0 : scrollTopPosition;

                if (lastScrollTop >= scrollLength && headerContainer && !headerContainer.classList.contains(cssClass)) {
                    headerContainer.classList.add(cssClass);
                } else if (lastScrollTop < scrollLength && headerContainer && headerContainer.classList.contains(cssClass)) {
                    headerContainer.classList.remove(cssClass);
                }
            },
            false
        );
    };

    Menu.prototype.initializeMegaMenu = function initializeMegaMenu () {
        var burger = document.querySelector('.burger');
        var megamenu = document.querySelector('.megamenu');
        var header = document.querySelector('.header__container');
        var headerLeft = document.querySelector('.header__container-left');
        var logo = document.querySelector('.header__container-logo');
        var items = document.querySelectorAll('.megamenu li a');
        var classHidden = 'is-hidden';
        burger.addEventListener("click", function (event) {
            if (megamenu.classList.contains(classHidden)) {
                megamenu.classList.remove(classHidden);
                document.documentElement.style.overflow = 'hidden';
            } else {
                megamenu.classList.add(classHidden);
                document.documentElement.style.overflow = '';
            }
            if (header.classList.contains(classHidden)) {
                header.classList.remove(classHidden);
            } else {
                header.classList.add(classHidden);
            }
            if (headerLeft.classList.contains(classHidden)) {
                headerLeft.classList.remove(classHidden);
            } else {
                headerLeft.classList.add(classHidden);
            }
            if (logo.classList.contains(classHidden)) {
                logo.classList.remove(classHidden);
            } else {
                logo.classList.add(classHidden);
            }
        });

        items.forEach(function (item) {
            item.addEventListener('click', function (event) {
                burger.click();
            });
        });
    };

    document.addEventListener('DOMContentLoaded', function () {
        new Menu();
    });

})));
//# sourceMappingURL=main.min.js.map
